export function formatNumber(num, unit = "", showUnitBefore = false) {
  if (num === null || num === undefined) return "";

  // Se o número for exatamente zero
  if (Number(num) === 0) return "0";

  // Converte para número diretamente (JavaScript lida com pontos decimais corretamente)
  const n = Number(num);

  if (isNaN(n)) return "";
  let formatted = "";

  // Mesma lógica de milhar/milhão
  if (n >= 1000000) {
    formatted = (n / 1000000).toFixed(1).replace(".", ",") + "M";
  } else if (n >= 1000) {
    formatted = (n / 1000).toFixed(1).replace(".", ",") + "K";
  } else {
    formatted = n.toString();
  }

  // Aplica unidade se existir
  if (unit) {
    if (showUnitBefore) {
      return `${unit} ${formatted}`;
    } else {
      return `${formatted} ${unit}`;
    }
  }

  return formatted;
}
